module.exports = __webpack_public_path__ + "img/login-img.fb4a7896.svg";